const FONT_WEIGHT = {
  BOLD: 700,
  REGULAR: 500,
  LIGHT: 400,
} as const;

export default FONT_WEIGHT;
